<template>
  <div
    class="rounded-large group bg-surface-container relative flex w-full cursor-pointer flex-col items-center overflow-hidden"
    @click="navigateToImpulse"
  >
    <div class="rounded-large relative z-20 h-16 w-full shrink-0 overflow-hidden">
      <img
        v-if="impulse.image"
        :src="impulse.image"
        alt=""
        class="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105 group-hover:rotate-1"
      />
      <LessonImpulseBookmarkButton
        :impulse="impulse"
        color="filled"
        toggle
        class="absolute! top-3 right-3 z-30"
      />
      <div
        v-if="impulse.myLessonCounts.running > 0 || impulse.myLessonCounts.finished > 0"
        class="absolute top-3 left-3 z-30 flex flex-col items-start gap-1"
      >
        <RouterLink
          v-if="impulse.myLessonCounts.running > 0"
          :to="{ name: 'impulse-library' }"
          @click.stop
        >
          <div
            class="bg-primary text-on-primary rounded-small text-label-medium flex flex-row items-center gap-2 px-2 py-1"
          >
            <div class="bg-on-primary animate-color-pulse h-2 w-2 rounded-full"></div>
            <span>
              {{ $t('lumia.lesson.running') }}
            </span>
          </div>
        </RouterLink>
      </div>
    </div>
    <div class="flex w-full grow flex-col gap-2">
      <div class="flex grow flex-col px-4 py-2">
        <h3 class="text-title-medium">{{ impulse.title }}</h3>
      </div>
      <div
        class="border-outline-variant text-body-medium text-on-surface-variant flex flex-row flex-wrap items-center gap-0.5 border-t p-4"
      >
        <LessonImpulseSubjects :subjects="impulse.subjects" class="font-medium" />
        ・
        <span class="inline-flex flex-row items-center gap-1">
          <BaseIcon size="18">schedule</BaseIcon
          >{{ $t('lumia.numberOfLessons', { count: impulse.numberOfLessons }) }}
        </span>
        <span
          v-if="impulse.myLessonCounts.finished > 0"
          v-tooltip="
            `${$t('lumia.lesson.myCountFinished', { count: impulse.myLessonCounts.finished })}`
          "
          class="inline-flex flex-row items-center gap-0.5"
        >
          ・ <BaseIcon size="18">repeat</BaseIcon> {{ impulse.myLessonCounts.finished }}
        </span>
      </div>
    </div>
    <BaseStateLayer />
  </div>
</template>
<script lang="ts" setup>
  import { useRouter } from 'vue-router'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import { type LessonImpulseSummary } from '../models/lesson-impulse.ts'
  import LessonImpulseSubjects from './LessonImpulseSubjects.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import LessonImpulseBookmarkButton from './LessonImpulseBookmarkButton.vue'

  interface Props {
    impulse: LessonImpulseSummary
  }

  const props = defineProps<Props>()
  const router = useRouter()

  const navigateToImpulse = () => {
    router.push({
      name: 'impulse-library-detail',
      params: { id: props.impulse.id },
    })
  }
</script>
